import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

/** Resolves a CTC division string to a Firetrol division, creating it on first use. */
export function useGetOrCreateCtcDivision() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (division: string) =>
      ctcApiClient.getOrCreateCTCDivision(division),
    meta: { silent: true, errorContext: 'CTC division' },
    onSettled: () => invalidateFor('divisions.sync', qc),
  });
}
